import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'significantDecimal',
})
export class SignificantDecimalPipe implements PipeTransform {
  transform(value: number, significantFigureDecimals: number = 3): string {
    if (value === null || value === undefined) {
      return '-';
    }

    const [integerPart, decimalPart] = value.toString().split('.');

    if (integerPart != '0') {
      return value.toFixed(significantFigureDecimals);
    }
    if (!decimalPart || significantFigureDecimals === 0) {
      return integerPart; // No decimal part or no significant figures requested
    }

    // Take only the desired number of digits after the decimal point
    const truncatedDecimal = parseFloat(`0.${decimalPart}`).toPrecision(significantFigureDecimals).split('.')[1]; //decimalPart.slice(0, significantFigureDecimals);

    return `${integerPart}.${truncatedDecimal}`;
  }
}
